import React, {useCallback, useEffect, useState} from "react";

import {Info} from "@churchofjesuschrist/eden-banner";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

import useToggle from "../../../generic/hooks/use-toggle/use-toggle";
import LoadingModal from "../../../generic/loading/loading-modal/loading-modal";
import useManagedStrings from "../../../utils/use-managed-strings";
import TopBar from "../../top-bar/top-bar";
import UserOptions from "../../user-options/user-options";
import MobileTopMenu from "../mobile-top-menu/mobile-top-menu";
import MobileViewContext from "../mobile-view-context";

const RelativeDiv = styled.div`
position:relative;
`
const stringGroups = [
  {
    name:"shared",
    keys:["mobileNotice"]
  }
]

const MobileLayout = ({
  topBarProps,
  userOptionsProps,
  programTreeProps,
  programSearchProps,
  navigationStatus,
  children}) => {
  const location = useLocation();
  const loading = navigationStatus?.saving;
  const [isMobileLayout, setIsMobileLayout] = useState(false);
  const [childMenuContents,setChildMenuContents] = useState(undefined);
  const [helpArticle,setHelpArticle] = useState(undefined);

  const [open,toggleOpen] = useToggle();

  const onSetUpMobileLayout = useCallback(({menuContents,helpArticle}) => {
    setIsMobileLayout(true);
    setChildMenuContents(menuContents);
    setHelpArticle(helpArticle);
  },[]);
  const onTurnOffMobileLayout = useCallback(() => {
    setIsMobileLayout(false);
    setChildMenuContents(undefined);
    setHelpArticle(undefined);
  },[]);

  useEffect(() => {
    onTurnOffMobileLayout();
  }, [location, onTurnOffMobileLayout]);

  const { managedStrings } = useManagedStrings(stringGroups);
  return (<div>
    <LoadingModal
      active={loading}
      data-id="global-loading-modal"
    />
    <MobileViewContext.Provider value={{
      isMobile:true,
      onSetUpMobileLayout,
      onTurnOffMobileLayout,
      toggleMenuOpen:toggleOpen
    }}>
      <RelativeDiv>
        {!open && (
          <TopBar
            hamburgerClick={toggleOpen}
            {...topBarProps}
            isMobile={true}>
            {(closeMenu) => (
              <UserOptions
                {...userOptionsProps}
                closeMenu={closeMenu}/>)}
          </TopBar>)}
      </RelativeDiv>
      {open && (
        <MobileTopMenu theme={topBarProps?.theme}
          programTreeProps={programTreeProps}
          programSearchProps={programSearchProps}
          helpArticle = {helpArticle}
          onClose={toggleOpen}>
          {childMenuContents}
        </MobileTopMenu>)}
      {!isMobileLayout && (<Info description={managedStrings.mobileNotice}/>)}
      {children}
    </MobileViewContext.Provider>
  </div>)};


export default MobileLayout;
